import { FormControl, FormGroup } from '@angular/forms';

import { Level } from '@enums/level.enum';
import { MissionAcceptanceAcceptation } from '@models/mission-acceptance/mission-acceptance-acceptation';
import { ToFormGroupType } from '@modules/core/types/to-form-group';

export type MissionAcceptanceAcceptationFormType = ToFormGroupType<Required<MissionAcceptanceAcceptation>>;

export class MissionAcceptanceAcceptationForm extends FormGroup<MissionAcceptanceAcceptationFormType> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined),
      clientContacted: new FormControl<boolean | null>(null),
      companyInvestigation: new FormControl<boolean | null>(null),
      activityRisk: new FormControl<Level | null>(null),
      legalCharacteristicsRisk: new FormControl<Level | null>(null),
      fiscalSocialClientHistoryRisk: new FormControl<Level | null>(null),
      accountingOrganizationRisk: new FormControl<Level | null>(null),
      missionObject: new FormControl<boolean | null>(null),
      clientAdditionalNeeds: new FormControl<boolean | null>(null),
      specificDeadlines: new FormControl<boolean | null>(null),
      independentFromClient: new FormControl<boolean | null>(null),
      legalStructureCompetentForMission: new FormControl<boolean | null>(null),
      companyConsistentWithPartnerMethods: new FormControl<boolean | null>(null),
      contractConsistentWithProposedMission: new FormControl<boolean | null>(null)
    });
  }

  fromMissionAcceptanceAcceptation(missionAcceptanceAcceptation: MissionAcceptanceAcceptation): void {
    this.patchValue({
      id: missionAcceptanceAcceptation.id,
      clientContacted: missionAcceptanceAcceptation.clientContacted,
      companyInvestigation: missionAcceptanceAcceptation.companyInvestigation,
      activityRisk: missionAcceptanceAcceptation.activityRisk,
      legalCharacteristicsRisk: missionAcceptanceAcceptation.legalCharacteristicsRisk,
      fiscalSocialClientHistoryRisk: missionAcceptanceAcceptation.fiscalSocialClientHistoryRisk,
      accountingOrganizationRisk: missionAcceptanceAcceptation.accountingOrganizationRisk,
      missionObject: missionAcceptanceAcceptation.missionObject,
      clientAdditionalNeeds: missionAcceptanceAcceptation.clientAdditionalNeeds,
      specificDeadlines: missionAcceptanceAcceptation.specificDeadlines,
      independentFromClient: missionAcceptanceAcceptation.independentFromClient,
      legalStructureCompetentForMission: missionAcceptanceAcceptation.legalStructureCompetentForMission,
      companyConsistentWithPartnerMethods: missionAcceptanceAcceptation.companyConsistentWithPartnerMethods,
      contractConsistentWithProposedMission: missionAcceptanceAcceptation.contractConsistentWithProposedMission
    });
  }

  toMissionAcceptanceAcceptation(): MissionAcceptanceAcceptation {
    const missionAcceptanceAcceptation = new MissionAcceptanceAcceptation();

    missionAcceptanceAcceptation.id = this.controls.id.value;
    missionAcceptanceAcceptation.clientContacted = this.controls.clientContacted.value ?? null;
    missionAcceptanceAcceptation.companyInvestigation = this.controls.companyInvestigation.value ?? null;
    missionAcceptanceAcceptation.activityRisk = this.controls.activityRisk.value ?? null;
    missionAcceptanceAcceptation.legalCharacteristicsRisk = this.controls.legalCharacteristicsRisk.value ?? null;
    missionAcceptanceAcceptation.fiscalSocialClientHistoryRisk =
      this.controls.fiscalSocialClientHistoryRisk.value ?? null;
    missionAcceptanceAcceptation.accountingOrganizationRisk = this.controls.accountingOrganizationRisk.value ?? null;
    missionAcceptanceAcceptation.missionObject = this.controls.missionObject.value ?? null;
    missionAcceptanceAcceptation.clientAdditionalNeeds = this.controls.clientAdditionalNeeds.value ?? null;
    missionAcceptanceAcceptation.specificDeadlines = this.controls.specificDeadlines.value ?? null;
    missionAcceptanceAcceptation.independentFromClient = this.controls.independentFromClient.value ?? null;
    missionAcceptanceAcceptation.legalStructureCompetentForMission =
      this.controls.legalStructureCompetentForMission.value ?? null;
    missionAcceptanceAcceptation.companyConsistentWithPartnerMethods =
      this.controls.companyConsistentWithPartnerMethods.value ?? null;
    missionAcceptanceAcceptation.contractConsistentWithProposedMission =
      this.controls.contractConsistentWithProposedMission.value ?? null;

    return missionAcceptanceAcceptation;
  }
}
